<template>
    <div class="notice-info-wrap">
        <div class="info-wrap">
            <div class="top-logo">
                <img :src="loginT"/>
            </div>
            <div class="content-wrap" v-loading="loading">
                <div class="datail-title">{{content.title}}</div>
                <div class="time-bar" v-show="content.createTime">
                    <div class="time-info">
                        <span>发布日期：{{content.createTime}}</span>
                    </div>
                </div>
                <div class="artucle-info">
                    <div class="info-a">
                        致：各位供应商
                    </div>
                    <div class="info-b">
                        我公司需求以下规格材料/物资/服务,请贵公司收到询价单后,请按我公司模板于{{content.bjJzTime}}前将报价信息在本平台进行填报与提交，我方将择期开展价格、交付周期、交付质量的综合评审及谈价，确定采购供应商。
                    </div>
                    <div class="info-b">注:请各供应商仔细阅读以下要求并遵照执行:</div>
                    <div class="info-b">1.在要求时间内进行报价并提交,过期视为无效报价，对曾经有过供货;若非特殊原因,虚高报价,一经发现,我公司将停止后期对贵司询价，请各单位予以重视。</div>
                    <div class="info-b">2.报价表格严格按要求顺序、项目进行填报，不能报价请进行标记说明。</div>
                    <div class="info-b">3.若有其他需要说明的情况,请在备注栏注明。</div>
                    <div class="info-b">4.交付周期为自下单之日起至货物到达公司的仓库时间，若未在承诺时间内到货，我方将有权拒绝收货。</div>
                    <div class="info-b" style="margin-top:50px">附件：
                        <a v-if="content.fileSrc":href="baseURL+content.fileSrc">下载附件</a>
                        <a v-if="!content.fileSrc" href="#">无附件</a>
                    </div>

                    <div class="info-b" style="margin-top:10">采购清单：</div>
                    <div class="info-b">详见采购询价单：<span class="link-span" @click="showOrder">{{content.orderCode}}</span></div>
                    <div class="info-b" style="margin-top:10">

                    </div>
                    <div class="info-c">
                        <div>
                            <p>利联采购部</p>
                            <p>{{date}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginT from '../../../assets/login_logo1.png'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor';
import { sourcNoticeById } from '../../../api/notice'
export default {
    components: {
        quillEditor
    },
    props: {

    },
    data() {
        return {
            loginT,
            content:{},
            noticeId:'',
            date:'',
        };
    },
    computed: {

    },
    created() {
        let route = this.$route;
        this.noticeId = route.params.id;  // 详情id
        this.getinfo()
        // let info = localStorage.getItem('editorTest');
        // if(info){
        //     this.content = JSON.parse(info)
        // }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        getinfo(){
            let _this = this;
            this.loading = true;
            sourcNoticeById({id:this.noticeId}).then(({data:res})=>{
                _this.loading = false;
                if(res.code == 0){
                    console.log(res)
                    _this.content = res.data;
                    if(_this.content.createTime){
                        let dateArr = _this.content.createTime.split(' ')[0].split('-')
                        _this.date = `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
                    }
                }
            })
        },
        showOrder(){
            this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${this.content.orderId}&show=false`});
        },
    },
};
</script>

<style lang="scss">
    .notice-info-wrap{
        .link-span{
            cursor: pointer;
            color: #ff9811;
        }
        width: 100%;
        min-height: 100vh;
        background: #F6F9FD;
        .info-wrap{
            width: 1240px;
            margin: 0 auto;
        }
        .top-logo{

            width: 100%;
            height: 40px;
            padding: 20px 0;
            text-align: left;
            img{
                height: 40px;
            }
        }
        .content-wrap{
            width: calc(100% - 40px);
            padding: 20px;
            background: #fff;
            min-height: calc(100vh - 140px);
            .datail-title{
                width: 100%;
                line-height: 30px;
                text-align: center;
                font-size: 20px;
                font-weight: 700;
                color: #535353;
            }
            .time-bar{
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 10px;
                margin-bottom: 20px;
                div{
                    padding-top: 10px;
                    border-top:1px solid #e0e0e0 ;
                    font-size: 12px;
                    color: #535353;
                    span{
                        margin: 0 10px;
                    }
                }
            }
            .artucle-info{
                width: calc(100% - 200px);
                padding: 0 100px;
                margin-bottom: 50px;
                font-size: 14px;
                .info-a{
                    color: #666;
                    line-height: 50px;
                }
                .info-b{
                    width: 100%;
                    line-height: 30px;
                    text-indent: 2em;
                    /* font-size: 12px; */
                    color: #333;
                }
                .info-c{
                    margin-top: 100px;
                    overflow: hidden;
                    color: #666;
                    div{
                        text-align: center;
                        float:right;
                    }
                }
            }
        }

    }
</style>
